import vButton from "./v-button.vue";
import vCornerButton from "./v-corner-button.vue";

export default Vue => {
  Vue.component("v-button", vButton);
  Vue.component("v-corner-button", vCornerButton);
};
